import { z } from 'zod';

import { listOutput, page } from './common';
import { defineEndpoint } from './endpoint';

/** Em nome de quem a venda sai (spec VENDA-PELA-ALIANCA §4): um parceiro ou a própria Aliança, que não é parceiro. */
export const TITULAR_ALIANCA = 'alianca';
export const TitularDaVenda = z.enum(['parceiro', TITULAR_ALIANCA]);
export type TitularDaVenda = z.infer<typeof TitularDaVenda>;

/** A escolha de quem pode escolher: o id de um parceiro ativo ou a Aliança. */
export const EscolhaDeTitular = z.union([z.uuid(), z.literal(TITULAR_ALIANCA)]);
export type EscolhaDeTitular = z.infer<typeof EscolhaDeTitular>;

/** Como a venda da Aliança aparece nas listas, filtros e escolhas (API e tela). */
export const NOME_DA_VENDA_DIRETA = 'Aliança (venda direta)';

/** O que falta antes de vender, para quem escolhe o titular (servidor recusa e tela avisa com a mesma frase). */
export const ESCOLHA_O_TITULAR = 'Escolha em nome de quem a venda sai';

/** Nome de quem fica com a venda: a venda direta da Aliança ou o parceiro (nulo sem parceiro). */
export const nomeDoTitular = (titular: string | null, parceiroNome: string | null): string | null =>
  titular === TITULAR_ALIANCA ? NOME_DA_VENDA_DIRETA : parceiroNome;

/** O titular gravado (contrato, proposta) como escolha da tela; linha antiga sem parceiro não vira escolha. */
export const escolhaDoTitular = (titular: string, parceiroId: string | null): EscolhaDeTitular | null =>
  titular === TITULAR_ALIANCA ? TITULAR_ALIANCA : parceiroId;

export const TitularOpcao = z.object({ valor: EscolhaDeTitular, nome: z.string() });
export type TitularOpcao = z.infer<typeof TitularOpcao>;

export const listarTitularesDaVenda = defineEndpoint({
  method: 'GET',
  path: '/api/vendas/titulares',
  query: z.object({ ...page }),
  output: listOutput(TitularOpcao),
});
